import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setDefaultPaymentMethod } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { PaymentMethodDto } from '@/types/subscription';

export const useSetDefaultPaymentMethod = () => {
    const queryClient = useQueryClient();
    return useMutation<PaymentMethodDto, unknown, string>({
        mutationFn: setDefaultPaymentMethod,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.paymentMethods() });
        },
    });
};
